import { useTranslations } from "use-intl";

import { buildReleaseFormatSummaryDisplay } from "@/lib/release-format-display";
import type { MediaFormatSummaryItem } from "@garimpa/lib/formats";

/** Shared edition packing for offer cards and rows, with a category fallback. */
export function useOfferMediaPacking(
  summary: MediaFormatSummaryItem[] | undefined,
  format: string | null | undefined,
) {
  const formatMessages = useTranslations("shared.formats");
  const categories = useTranslations("shared.releaseFilters");
  return (
    buildReleaseFormatSummaryDisplay(summary ?? [], { formatMessages }).summaryText ??
    (categories.has(format ?? "other") ? categories(format ?? "other") : (format ?? ""))
  );
}
